module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAGBAMAAADnHHnLAAAAElBMVEVlZWVmZmZlZWVHcExmZmZmZmajjnylAAAABnRSTlNm/FsA66KkkTbKAAAAL0lEQVQI12NwMDY2NnBgYGQ2NmZkYDAQMDYQMmAwVmRmVAZSRqJCxkDKWEXZ2AAAbg0FROPTi7AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/topbar/arrowdown.png
// module id = pTun
// module chunks = 1